import { useEffect, useState } from 'react';
import cx from 'classnames';
import type { SplatLoadingPhase } from '../../state/sceneLoading';
import styles from './SceneProgressBar.module.css';

const FETCH_PHASE_MAX = 70;
const FAKE_PHASE_MAX = 90;

type SceneProgressBarProps = {
  visible: boolean;
  splatLoadedBytes: number;
  splatTotalBytes: number | null;
  splatPhase: SplatLoadingPhase;
};

const computeFetchPercent = (loaded: number, total: number | null): number => {
  if (!total || total <= 0) {
    return 0;
  }
  return Math.min((loaded / total) * FETCH_PHASE_MAX, FETCH_PHASE_MAX);
};

export const SceneProgressBar = ({
  visible,
  splatLoadedBytes,
  splatTotalBytes,
  splatPhase,
}: SceneProgressBarProps) => {
  const [displayPercent, setDisplayPercent] = useState(0);

  useEffect(() => {
    if (splatPhase === 'ready') {
      setDisplayPercent(100);
      return;
    }

    if (splatPhase === 'initializing') {
      setDisplayPercent(FAKE_PHASE_MAX);
      return;
    }

    if (splatPhase === 'fetching') {
      const fetchPercent = computeFetchPercent(splatLoadedBytes, splatTotalBytes);
      setDisplayPercent(Math.round(fetchPercent));
    }
  }, [splatLoadedBytes, splatTotalBytes, splatPhase]);

  return (
    <div className={cx(styles.wrapper, !visible && styles.hidden)}>
      <span className={styles.label}>{displayPercent}%</span>
    </div>
  );
};
